import React from "react";
import { ComponentProps, ComponentWidth, Image } from "../../../types";
import DivWrapper from "../../containers/DivWrapper";
import { OneThirdSummaryDisplay } from "../SummaryDisplay/OneThirdSummaryDisplay";
import * as styles from "./StaffMembers.module.css";

interface Props extends ComponentProps, ComponentWidth {
  heading: string;
  staffMembers: {
    firstName: string;
    lastName: string;
    title: string;
    image: Image;
  }[];
  showImages: boolean;
}

export const StaffMembers: React.FC<Props> = ({
  staffMembers,
  showImages,
  heading,
  id,
  ...props
}) => {
  const transformStaffMembers = staffMembers.map((staffMember, idx) => ({
    subhead: `${staffMember.firstName} ${staffMember.lastName}`,
    image: staffMember.image,
    text: {
      value: staffMember.title,
    },
    className: styles.staffMember,
  }));

  return (
    <DivWrapper {...props} id={id}>
      <div className={styles.staffMembers}>
        {heading && (
          <div>
            <h2 data-kontent-element-codename="heading">{heading}</h2>
          </div>
        )}
        <div data-kontent-element-codename="staff_members">
          <OneThirdSummaryDisplay
            {...props}
            id={""}
            summaries={transformStaffMembers}
            tileLayout={"quarters"}
            displayImages={showImages}
            animate={false}
          />
        </div>
      </div>
    </DivWrapper>
  );
};
